import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {
  DeleteUserPreferenceRequest,
  ListUserPreferencesRequest,
  ListUserPreferencesResponse,
  UpdateUserPreferenceResponse,
  UserPreference
} from '@ot/shared/model';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import {
  EnvironmentConfigModel,
  EnvironmentConfigService
} from '../environment';

@Injectable({ providedIn: 'root' })
export class UserPreferencesAPIService {
  apiUrl: string;
  readonly apiPath = '/application-user-preference-service/v1';

  constructor(
    private environmentConfigService: EnvironmentConfigService,
    private http: HttpClient
  ) {
    const envConfigs: EnvironmentConfigModel = this.environmentConfigService.getEnvironmentConfigs();
    this.apiUrl = envConfigs.apis.platform.url + this.apiPath;
  }

  updateUserPreference(request: UserPreference): Observable<UserPreference> {
    const url = `${this.apiUrl}/applicationuserpreference`;
    return this.http
      .put<UpdateUserPreferenceResponse>(url, request)
      .pipe(map(response => response.applicationUserPreference));
  }

  deleteUserPreference(request: DeleteUserPreferenceRequest): Observable<{}> {
    const url = `${this.apiUrl}/applicationuserpreference`;
    return this.http.request<{}>('delete', url, { body: request });
  }

  listUserPreferences(
    request: ListUserPreferencesRequest
  ): Observable<UserPreference[]> {
    const url = `${this.apiUrl}/applicationuserpreferences:list`;
    return this.http
      .post<ListUserPreferencesResponse>(url, request)
      .pipe(map(response => response.applicationUserPreferences));
  }
}
